import { proxy } from 'valtio';
import { TrackedError, TrackedEvent } from './types';

export type DiagnosticsState = {
  errors: TrackedError[];
  events: TrackedEvent[];
  drawerOpen: boolean;
};

export const diagnosticsState = proxy<DiagnosticsState>({
  errors: [],
  events: [],
  drawerOpen: false,
});
